module.exports = __webpack_public_path__ + "img/client-4.be350b2a.png";